"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkPhone = exports.checkEmail = exports.getWeekday = exports.DTS = exports.DT = exports.zeroPadding = exports.getDayNames = exports.UiState = void 0;
var reconnect_js_1 = require("reconnect.js");
var LocaleOutlet = (0, reconnect_js_1.getOutlet)('locale');
exports.UiState = {
  CHOOSE_TIME: 0,
  CHOOSE_ROOM: 1,
  CONFIRM: 2
};
function getDayNames() {
  var dic = {
    en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    tw: ['日', '一', '二', '三', '四', '五', '六']
  };
  return dic[LocaleOutlet.getValue().lang];
}
exports.getDayNames = getDayNames;
function zeroPadding(x) {
  return ('00' + x).slice(-2);
}
exports.zeroPadding = zeroPadding;
function DT(_a) {
  var year = _a.year,
    month = _a.month,
    date = _a.date;
  return new Date(year, month, date);
}
exports.DT = DT;
function DTS(_a) {
  var year = _a.year,
    month = _a.month,
    date = _a.date;
  return "".concat(year, "-").concat(zeroPadding(month + 1), "-").concat(zeroPadding(date));
}
exports.DTS = DTS;
function getWeekday(_a) {
  var year = _a.year,
    month = _a.month,
    date = _a.date;
  var _date = new Date(year, month, date);
  // month start from 0
  // Sunday = 0, Monday = 1, ... (See below):
  var weekday = _date.getDay();
  var DAY_NAMES = getDayNames();
  return DAY_NAMES[weekday];
}
exports.getWeekday = getWeekday;
function checkEmail(email) {
  var emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  return emailPattern.test(email);
}
exports.checkEmail = checkEmail;
function checkPhone(phone) {
  var phonePattern = /^09[0-9]{8}$/;
  return phonePattern.test(phone);
}
exports.checkPhone = checkPhone;